<!-- =========================================================================================
  File Name: UserList.vue
  Description: Integration Users List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <div class="vx-row p-4" style="float:right!important;">
      <div class="vx-col-12" style="float:right!important;">
        <vs-button color="primary" style="float:right!important;" type="filled" icon-pack="feather"
          icon="icon-plus-circle" @click="$router.push(`/module-actions/add/${$route.params.moduleHash}`)">{{
            $t('CUSTOM.add')
          }}</vs-button>
      </div>
    </div>
    <br><br><br>

    <!-- <div class="vx-card p-6"> -->
    <vx-card>
      <vs-table multiple v-model="selectedRows" :sst="false" @search="handleSearch" @change-page="handleChangePage"
        @sort="handleSort" pagination max-items="10" search :data="rows">

        <template slot="header">
          <h3>{{ $t('MODULE_ACTIONS.tableTitle') }}</h3>
        </template>

        <template slot="thead">
          <vs-th sort-key="name">{{ $t('MODULE_ACTIONS.name') }}</vs-th>
          <vs-th sort-key="icon">{{ $t('MODULE_ACTIONS.icon') }}</vs-th>
          <vs-th sort-key="index">{{ $t('MODULE_ACTIONS.index') }}</vs-th>
          <vs-th sort-key="url">{{ $t('MODULE_ACTIONS.url') }}</vs-th>
          <vs-th sort-key="actions">{{ $t('MODULE_ACTIONS.actions') }}</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

            <vs-td :data="data[indextr].name">
              {{ data[indextr].name }}
            </vs-td>

            <vs-td :data="data[indextr].icon">
              <feather-icon :icon="data[indextr].icon" svgClasses="h-5 w-5 mr-2 hover:text-primary cursor-pointer" />{{
            data[indextr].icon }}
            </vs-td>

            <vs-td :data="data[indextr].index">
              {{ data[indextr].index }}
            </vs-td>

            <vs-td :data="data[indextr].url">
              {{ data[indextr].url }}
            </vs-td>

            <vs-td>
              <!-- <feather-icon icon="EyeIcon" svgClasses="h-5 w-5 mr-4 hover:text-warning cursor-pointer"
                @click="viewIntegrationUserDetail(data[indextr]['hash'])" /> -->
              <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
                @click="$router.push(`/module-actions/edit/${$route.params.moduleHash}/${data[indextr]['hash']}`)" />
              <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 mr-4 hover:text-danger cursor-pointer"
                @click="confirmDeleteRecord(data[indextr]['hash'])" />
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { setApplicationLocalStorageItem, performFetch } from '../../helpers'

export default {
  components: {
    vSelect
  },
  data: () => ({
    selectedRows: [],
    rows: []
  }),
  watch: {
    selectedRows(value) {
      // console.log(value)
    },

  },
  mounted() {
    document.querySelector('.vx-card').style.backgroundColor = '#fff'
    document.title = `${document.title.split(' | ')[0]} | Usuários de Integração`
  },
  methods: {
    async getData() {
      this.$vs.loading({ type: 'default' });
      await performFetch(this.$store.state.auth.api_url, {
        command: 'module_action__list',
        parameters: {
          application_token: this.$store.state.auth.app_token,
          session_token: this.$store.state.auth.token,
          module_hash: this.$route.params.moduleHash
        }
      })
        .then(async (response) => {
          if (response.status === 200) {
            response.json().then(async (response) => {

              this.rows = response.actions

              this.$vs.loading.close();

            })
          } else if (response.status == 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          } else {
            //this.$vs.loading.close()
          }
        })
        .catch((e) => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: $t('CUSTOM.operationPerformed'),
            text: e.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
          throw new Error(e.message)
        })
    },
    onSelectClick() {

      if (!this.showBlankContent) {

        try {
          const offsetHeight = document.querySelector('.vs__dropdown-menu').offsetHeight

          document.querySelector('#blank_content').style.height = offsetHeight + 'px'

          this.showBlankContent = true
        } catch (e) {
          //
        }
      }
    },
    onSelectEditClick() {

      if (!this.showBlankContentEdit) {

        try {
          const offsetHeight = document.querySelector('.vs__dropdown-menu').offsetHeight

          document.querySelector('#blank_content_edit').style.height = offsetHeight + 'px'

          this.showBlankContentEdit = true
        } catch (e) {
          //
        }
      }
    },
    handleSearch(searching) {
      console.log(`The user searched for: ${searching}`)
    },
    handleChangePage(page) {
      console.log(`The user changed the page to: ${page}`)
    },
    handleSort(key, active) {
      console.log(`the user ordered: ${key} ${active}`)
    },
    clearAddForm() {
      this.addIntegrationUserData.name = ''
      this.addIntegrationUserData.role = {}
    },
    clearEditForm() {
      this.editIntegrationUserData.name = ''
      this.editIntegrationUserData.role = {}
    },
    validateAddForm() {
      if (this.addIntegrationUserData.name === '' || this.addIntegrationUserData.name === null) {
        this.$vs.notify({
          title: this.$t('USER_INTEGRATION.attention'),
          text: this.$t('USER_INTEGRATION.fieldRequired', { field: this.$t('USER_INTEGRATION.name') }),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }

      if (JSON.stringify(this.addIntegrationUserData.role) === '{}') {
        this.$vs.notify({
          title: this.$t('USER_INTEGRATION.attention'),
          text: this.$t('USER_INTEGRATION.fieldRequired', { field: this.$t('USER_INTEGRATION.role') }),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }

      return true
    },
    validateEditForm() {
      if (this.editIntegrationUserData.name === '' || this.editIntegrationUserData.name === null) {
        this.$vs.notify({
          title: this.$t('USER_INTEGRATION.attention'),
          text: this.$t('USER_INTEGRATION.fieldRequired', { field: this.$t('USER_INTEGRATION.name') }),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }

      if (JSON.stringify(this.editIntegrationUserData.role) === '{}') {
        this.$vs.notify({
          title: this.$t('USER_INTEGRATION.attention'),
          text: this.$t('USER_INTEGRATION.fieldRequired', { field: this.$t('USER_INTEGRATION.role') }),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }

      return true
    },
    confirmDeleteRecord(rowHash) {
      this.rowHashToDelete = rowHash
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: this.$t('USER_INTEGRATION.confirmDeletionTitle'),
        text: this.$t('USER_INTEGRATION.confirmDeletionText'),
        accept: this.deleteRecord,
        acceptText: this.$t('USER_INTEGRATION.delete')
      })
    },
    async deleteRecord() {

      this.$vs.loading({ type: 'default' })

      await performFetch(`${this.$store.state.auth.api_url}`, {
        command: 'module_action__delete',
        parameters: {
          application_token: this.$store.state.auth.app_token,
          session_token: this.$store.state.auth.token,
          action_hash: this.rowHashToDelete
        }
      })
        .then(async (response) => {
          if (response.status === 200) {
            response.json().then(async (response) => {

              this.$vs.notify({
                title: this.$t('CUSTOM.operationPerformed'),
                text: this.$t('MODULE_ACTIONS.actionDeleted'),
                iconPack: 'feather',
                icon: 'icon-check',
                color: 'success'
              })

              await this.getData()

            })
          } else if (response.status == 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          } else {
            //this.$vs.loading.close()
          }
        })
        .catch((e) => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: this.$t('USER_INTEGRATION.attention'),
            text: e.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
          throw new Error(e.message)
        })

      this.rowHashToDelete = ''
    }
  },
  // async created() {
  //   await this.getIntegrationUsersParameters()
  //   await this.getIntegrationUsers()
  // }
  async mounted() {
    await this.getData();
  }
}
</script>

<!-- <style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  } -->
